import * as types from "./actionTypes";

export const fetchPerson = id => ({
  type: types.FETCH_PERSON,
  id
});

export const fetchPersonSuccess = person => ({
  type: types.FETCH_PERSON_SUCCESS,
  person
});

export const fetchPersonFail = err => ({
  type: types.FETCH_PERSON_FAIL,
  err
});

export const clearPerson = () => ({
  type: types.CLEAR_PERSON
});



// WEBPACK FOOTER //
// ./src/modules/person/actions.js